/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateCouponBatchShopifyCollectionsTarget { 
    /**
     * Target specific Shopify product collections.
     */
    type: CreateCouponBatchShopifyCollectionsTarget.TypeEnum;
    /**
     * Shopify Collection GIDs to target.
     */
    collectionIds: Array<string>;
}
export namespace CreateCouponBatchShopifyCollectionsTarget {
    export const TypeEnum = {
        Collections: 'collections'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


